import React, { useEffect } from "react";
import Common_title from '../common-components/common-title/Common_title';

const Terms_Conditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className='Privacy_policy'>
      <div className='container'>
        <Common_title subtitle="Terms & Conditions" />

        <div className='white_card'>

          <p className='point_title'>1. Business Details</p>
          <p className='descn_text'>
            <strong>Business Name:</strong> Gee Cart<br />
            <strong>Address:</strong> Bhaji Mandai, Siru Chouk, Gandhinagar, Karvir, Kolhapur - 416119
          </p>

          <br />

          <p className='point_title'>2. Contact Information</p>
          <p className='descn_text'>
             <strong>Email:</strong> <a href="mailto:girishharchandani1313@gmail.com">girishharchandani1313@gmail.com</a><br />
             <strong>Customer Care & WhatsApp:</strong> <a href="tel:+917020921927">+91 7020921927</a><br />
             <strong>Operating Hours:</strong> Monday to Sunday (10:00 AM – 11:00 PM)
          </p>

          <br />

          <p className='point_title'>3. Order Cut-Off & Delivery Timing</p>
          <p className='descn_text'>
             <strong>Order Cut-Off:</strong> Orders placed before 6:00 PM are processed for next-day delivery. Orders placed after 6:00 PM will be scheduled for the following delivery cycle.
          </p>
          <p className='descn_text'>
         <strong>Delivery Slots:</strong><br />
            • Slot 1: 4:00 PM – 7:00 PM<br />
            • Slot 2: 7:00 PM – 11:00 PM
          </p>

          <br />

          <p className='point_title'>4. Delivery Service Area</p>
          <p className='descn_text'>
             Currently serving: Wagholi, Pune and surrounding designated zones.
          </p>

          <br />

          <p className='point_title'>5. Order Modifications & Cancellations</p>
          <p className='descn_text'>
            • Orders can be edited or canceled only prior to the 6:00 PM cut-off time on the order date.<br />
            • No modifications or cancellations will be accepted once dispatch processing begins after 6:00 PM.
          </p>

          <br />

          <p className='point_title'>6. Inspection & Return Policy</p>
          <p className='descn_text'>
            • <strong>On-Delivery Inspection:</strong> You are requested to inspect all items upon arrival in front of the delivery executive.<br />
            • <strong>Instant Return:</strong> Any damaged, missing, or unsatisfactory items must be handed back directly to the delivery personnel at the time of delivery.<br />
            • <strong>No Post-Delivery Refunds:</strong> Once the delivery is accepted and completed, no return or refund requests will be entertained. You only pay for accepted items.
          </p>

          <br />

          <p className='point_title'>7. Prepaid Orders & Wallet Credit</p>
          <p className='descn_text'>
            • If an item in a prepaid order is rejected during on-delivery inspection or unavailable in stock, the corresponding amount will be credited to your <strong>Gee Cart Wallet</strong>.<br />
            • Wallet credits can be used toward future purchases on Gee Cart.<br />
            • Direct cash, UPI, or bank refunds will not be issued for rejected items.
          </p>

          <br />

          <p className='point_title'>8. Offers, Cashback & Promotions</p>
          <p className='descn_text'>
            • Promotional offers, referral rewards, and launch cashbacks are time-sensitive and subject to specific terms.<br />
            • Gee Cart reserves the right to modify, extend, or terminate promotional campaigns at any time without prior notice.
          </p>

          <br />

          <p className='point_title'>9. Limitation of Liability</p>
          <p className='descn_text'>
            Gee Cart is not held responsible for service delays or delivery disruptions caused by events beyond our reasonable control, including natural disasters, extreme weather conditions, traffic/transportation disruptions, civic strikes, or technical network outages.
          </p>

          <br />

          <p className='point_title'>10. Governing Law & Jurisdiction</p>
          <p className='descn_text'>
            These Terms and Conditions are governed by the laws of India. Any legal disputes or claims arising out of the use of our platform fall exclusively under the jurisdiction of courts in <strong>Pune, Maharashtra</strong>.
          </p>

          <br />

          <p className='point_title'>11. Updates to Terms</p>
          <p className='descn_text'>
            Gee Cart reserves the right to update or modify these Terms & Conditions at any time to reflect operational, legal, or regulatory changes. Continued usage of our website or application constitutes acceptance of the modified terms.
          </p>

        </div>
      </div>
    </section>
  );
};

export default Terms_Conditions;